import React, { useState } from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { ThemeProvider } from "styled-components";
//https://github.com/HubSpot/pace
import "pace";
import "pace/themes/red/pace-theme-flash.css";
import "moment/locale/en-gb";
import "moment/locale/nb";

import "normalize.css";
import "css/css.css";
import GlobalStyle from "css/GlobalStyle";
import theme from "css/theme.js";
import ImageGalleryContext from "./context/image-gallery-context";

import "polyfills.js";
import { store, persistor, maybePurgeStore } from "store";

import App from "./App";
import ReservationKeepAlive from "ReservationKeepAlive";
import ValidUserCheck from "ValidUserCheck";

// lazyload
//require('lazysizes');
//require('lazysizes/plugins/unveilhooks/ls.unveilhooks.min'); // support for background images

// purge store from local storage if persistor key changed
// current persistor key is returned by the server and attached as body attribute. Its then saved to local storage
// If persistor key from local storage !== current persistor key we purge the store and get new data
if (process.env.NODE_ENV !== "development") {
  maybePurgeStore(persistor);
}

const Router = () => {
  const [open, setOpen] = useState(false);
  return (
    <React.Fragment>
      <Provider store={store}>
        <ImageGalleryContext.Provider value={{ open, setOpen }}>
          <PersistGate loading={null} persistor={persistor}>
            <ReservationKeepAlive />
            <ValidUserCheck />
            <BrowserRouter>
              <ThemeProvider theme={theme}>
                <App />
              </ThemeProvider>
            </BrowserRouter>
          </PersistGate>
        </ImageGalleryContext.Provider>
      </Provider>
      <GlobalStyle />
    </React.Fragment>
  );
};

ReactDOM.render(<Router />, document.getElementById("root"));
